import { profilesConstants } from '@constants/profiles';

const initialState = {
    data: [],
    loading: true,
    error: '',
    totalCount: 0,
    pages: 1,
    conflictCount: 0,
    notPublishedCount: 0,
    inProgressCount: 0,
    naCount: 0,
    syncCompleted: true,
    syncedCount: 0,
    syncedWithConflictsCount: 0,
    filterData: [],
    filterLoading: true,
};

export function profiles(state = initialState, action) {
    switch (action.type) {
        case profilesConstants.PROFILES_FETCH:
            return { ...state, loading: true, error: '' };
        case profilesConstants.PROFILES_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data.data.items,
                totalCount: action.data.data.totalCount,
                pages: action.data.data.pages,
                conflictCount: action.data.conflictCount,
                notPublishedCount: action.data.notPublishedCount,
                inProgressCount: action.data.inProgressCount,
                naCount: action.data.naCount,
                syncCompleted: action.data.syncCompleted,
                syncedCount: action.data.syncedCount,
                syncedWithConflictsCount: action.data.syncedWithConflicts,
                error: '',
            };
        case profilesConstants.SET_SYNC_STATUS:
            return { ...state, syncCompleted: action.data.syncCompleted, loading: false, error: '' };
        case profilesConstants.PROFILES_ERROR:
            return { ...state, error: action.message, loading: false };
        case profilesConstants.SET_PROFILES:
            return { ...state, data: action.data };
        case profilesConstants.MARK_LOCATION_PUBLISHING:
            return { ...state, data: action.data, ...action.counts };
        case profilesConstants.PROFILES_FILTER_SUCCESS:
            return { ...state, filterData: action.data, filterLoading: false };
        case profilesConstants.PROFILES_FILTER_ERROR:
            return { ...state, filterLoading: false };
        default:
            return state;
    }
}
